import React, { useRef, useEffect, useState } from 'react';
import { MdRefresh } from 'react-icons/md';
import DefaultButton from '../../ReusableComponents/DefaultButton';
import useRegistrationConfiguration from '../useRegistrationConfiguration';
import { positionPayload } from '../registrationConfiguration';
import { usePortal } from '../hooks';
import PositionFields from './PositionFields';
import PositionAccessSettings from './PositionAccessSettings';
import PortalFormModal from './PortalFormModal';
import { ErrorNotice, Loading } from './Feedback';

function PositionEditor({ source, portal, mutation, allowed, onClose, onSaved }) {
  const form = useRef(null),
    snapshot = useRef(null);
  const [error, setError] = useState(null);
  const { labels } = usePortal();
  useEffect(() => {
    snapshot.current = JSON.parse(
      JSON.stringify(positionPayload(form.current.closest('form'), source, portal))
    );
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <PortalFormModal
      title={`Configurar ${labels.position.toLowerCase()}`}
      description={portal?.title || source.name}
      onClose={onClose}
      busy={mutation.isLoading}
      allowed={allowed}
      error={error || mutation.error}
      onSubmit={(event) => {
        try {
          const position = positionPayload(event.currentTarget, source, portal);
          if (position.portal.published && !position.source.portal_position_enabled) {
            setError(
              new Error('Habilite a inscrição na OnTest para publicar esta opção no portal.')
            );
            return;
          }
          setError(null);
          mutation.mutate(
            { position, saved: snapshot.current },
            {
              onSuccess: (result) => {
                onSaved(result);
                onClose();
              },
            }
          );
        } catch (failure) {
          setError(failure);
        }
      }}
    >
      <div className="portal-position-editor" ref={form}>
        <PositionFields
          position={{ source, portal }}
          prefix={`cargo_${source.id}_`}
          disabled={!allowed || mutation.isLoading}
        />
        <PositionAccessSettings source={source} prefix={`cargo_${source.id}_`} />
      </div>
    </PortalFormModal>
  );
}
export default function PositionConfigurationModal({
  selection,
  source,
  portal,
  onClose,
  onSaved,
}) {
  const query = useRegistrationConfiguration(selection, source);
  const initial = useRef(null);
  if (!initial.current && query.data) initial.current = { ...source, ...query.data };
  if (initial.current)
    return (
      <PositionEditor
        source={initial.current}
        portal={portal}
        mutation={query.save}
        allowed={query.allowed}
        onClose={onClose}
        onSaved={onSaved}
      />
    );
  return (
    <PortalFormModal
      title="Configurar acesso à inscrição"
      description={source.name}
      onClose={onClose}
      submitText={null}
      requiredNote={false}
      onSubmit={() => {}}
    >
      {query.isLoading ? (
        <Loading />
      ) : (
        <>
          <ErrorNotice
            error={query.error || new Error('Não foi possível carregar a configuração.')}
          />
          <DefaultButton
            text="Tentar novamente"
            bg="primary"
            icon={<MdRefresh />}
            onClick={() => query.refetch()}
          />
        </>
      )}
    </PortalFormModal>
  );
}
